// extracted by mini-css-extract-plugin
module.exports = {"tech":"tech_tech__1PKYr","techGround":"tech_techGround__I9BmM"};